import React, { FC } from 'react'
import styles from 'styles/components/typography.module.scss'

type Props = {
  headline: string
}

const Headline: FC<Props> = (props) => {
  const { headline } = props
  return <h2 className={styles.headline__card_main}>{headline}</h2>
}

export default Headline
